import get from 'lodash/get';
import { IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

import DataDisplay from 'src/models/Thread/Nodes/DataDisplayDef';
import EmailAuthCode from 'src/models/Thread/Nodes/EmailAuthenticateDef';
import ExitNode from 'src/models/Ivrs/Nodes/ExitNodeDef';
import ExternalData from 'src/models/Thread/Nodes/ExternalDataDef';
import InputNode from 'src/models/Ivrs/Nodes/InputNodeDef';
import { IsPropertyUniqueInStoreSlice } from 'src/actions/validators/IsPropertyUniqueInStoreSlice';
import MessageNode from 'src/models/Ivrs/Nodes/MessageNodeDef';
import NODE_TYPES from 'src/models/Ivrs/NodeTypes';
import Route from 'src/models/Thread/Nodes/RouteDef';
import ThreadMenuNode from './Nodes/ThreadMenuNodeDef';
import VariableMatchNode from 'src/models/Ivrs/Nodes/VariableMatchNodeDef';
import VariableNode from 'src/models/Ivrs/Nodes/VariableNodeDef';
import VerifyAuthCode from 'src/models/Thread/Nodes/VerifyAuthCodeDef';
export enum IVR_TAGS {
  CONSUMER_SELF_SERVICE = 'CONSUMER_SELF_SERVICE',
  WISMO = 'WISMO',
  TELEPHONY = 'TELEPHONY',
}

const nodeTypeClassMap = {
  IVR_NODE_DIAL: ExitNode,
  IVR_NODE_INPUT: InputNode,
  IVR_NODE_MENU: ThreadMenuNode,
  IVR_NODE_MESSAGE: MessageNode,
  IVR_NODE_VARIABLE: VariableNode,
  IVR_NODE_VARIABLE_MATCH: VariableMatchNode,

  IVR_NODE_EMAIL_AUTH_CODE: EmailAuthCode,
  IVR_NODE_EXTERNAL_DATA: ExternalData,
  IVR_NODE_DATA_DISPLAY: DataDisplay,
  IVR_NODE_VERIFY_AUTH_CODE: VerifyAuthCode,
  IVR_NODE_ROUTE: Route,
};

export class Node {
  @IsString()
  @IsNotEmpty()
  type: NODE_TYPES;

  @ValidateNested()
  @Type((typeHelper: any) => nodeTypeClassMap[get(typeHelper, 'object.type')])
  ivrNode:
    | DataDisplay
    | EmailAuthCode
    | ExitNode
    | ExternalData
    | InputNode
    | MessageNode
    | Route
    | ThreadMenuNode
    | VariableMatchNode
    | VariableNode
    | VerifyAuthCode;
}

export default class Thread {
  id: string;

  @IsNotEmpty({ message: 'Please enter a Thread name' })
  @IsPropertyUniqueInStoreSlice('threads', { message: 'This name already exists. Please use a new name.' })
  name: string;

  publishedAt?: string;
  publishedBy?: string;

  version: number;
  description: string;

  @IsString()
  @IsNotEmpty()
  rootNodeId: string;

  @ValidateNested({ each: true })
  @Type(() => Node)
  nodes: Node[];

  @IsNotEmpty()
  tags: IVR_TAGS[];

  debug: boolean;

  @IsOptional()
  @IsString()
  comment?: string;
}
